import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnCamera } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class CameraDescendantService {
  private readonly _created$ = new Subject<SnCamera>();
  private readonly _deleted$ = new Subject<SnCamera>();
  private readonly _updated$ = new Subject<SnCamera>();

  constructor() {}

  get created$(): Observable<SnCamera> {
    return this._created$.asObservable();
  }

  get updated$(): Observable<SnCamera> {
    return this._updated$.asObservable();
  }

  get deleted$(): Observable<SnCamera> {
    return this._deleted$.asObservable();
  }

  public onCreated(camera: SnCamera): void {
    this._created$.next(camera);
  }

  public onUpdated(camera: SnCamera): void {
    this._updated$.next(camera);
  }

  public onDeleted(camera: SnCamera): void {
    this._deleted$.next(camera);
  }
}
